import FileInputPanel from './FileInputPanel';

export default FileInputPanel;